import Audio from './audio';
import end from './audio/end.mp3';
import invitation from './audio/invitation.mp3';
import pick from './audio/pick.mp3';
const AUDIO_EVENTS = {
    invitation,
    pick,
    end,
};
export default class AudioController {
    machine;
    sounds = {};
    constructor(machine) {
        this.machine = machine;
        for (const [name, path] of Object.entries(AUDIO_EVENTS)) {
            this.sounds[name] = new Audio(path);
        }
        this.machine.on(this.machine.events.machineStateChanged, ({ trigger }) => {
            switch (trigger) {
                case 'pick': {
                    void this.play('pick');
                    break;
                }
                case 'endPick': {
                    this.pause('pick');
                    void this.play('end');
                    break;
                }
                case 'navigateOptionsList':
                case 'navigateError': {
                    for (const sound of Object.values(this.sounds)) {
                        sound.getElement().pause();
                    }
                    break;
                }
            }
        });
    }
    toggleMute(isSoundEnabled) {
        for (const sound of Object.values(this.sounds)) {
            sound.getElement().pause();
            sound.getElement().muted = !isSoundEnabled;
        }
    }
    async play(audioEvent) {
        const audioElement = this.sounds[audioEvent].getElement();
        audioElement.currentTime = 0;
        await audioElement.play();
    }
    pause(audioEvent) {
        const audioElement = this.sounds[audioEvent].getElement();
        audioElement.pause();
    }
}
